/* istanbul ignore file */
import { useEffect, useState } from 'react';
import _ from 'lodash';

export const useValidate = ({ validateFn, text, debounce = 0 }) => {
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [validationResponse, setValidationResponse] = useState(null);

  useEffect(() => {
    setIsValid(false);
    if (!text || !validateFn) {
      setError(null);
      setIsLoading(false);
      return;
    }
    const onChange = _.debounce(async () => {
      setIsLoading(true);
      try {
        const response = await validateFn(text);
        setValidationResponse(response);
        setError(null);
        setIsValid(true);
      } catch (e) {
        setValidationResponse(null);
        setError(e);
        setIsValid(false);
      }
      setIsLoading(false);
    }, debounce);
    onChange();
  }, [validateFn, text]);

  return {
    isValid,
    error,
    isLoading,
    validationResponse
  };
};
